export enum LocaleKeys {
  RU = 'ru',
  EN = 'en',
  JA = 'jp',
}
